import mussel from '../../assets/images/mussel3creamblurbright700.png';
import { Link } from 'react-router-dom';

function OurStory() {
  return (
    <div className="ourstory__container">
      <div className="ourstory__box column">
        <div className="ourstory-title">
          <h1 className="ourstory__title-text">우리의 이야기</h1>
        </div>
        <div className="ourstory__row row">
          <div className="ourstory__content">
            <div className="ourstory__content-box column">
              <div className="ourstory__content-title">
                <h1>모든 것은 뉴질랜드 초록입홍합에서 시작되었습니다 </h1>
                <h3>특유의 영양소를 보유한 해산물</h3>
              </div>
              <div className="ourstory__content-text">
                <p>뉴질랜드의 원주민 마오리족들은 뉴질랜드의 초록입홍합을 주식의 한 부분으로 섭취해 왔습니다. 학명상 'Perna canaliculus'라고 알려진 이 초록입홍합은 독특한 오메가3 필수 지방산, 단백질, 비타민, 미네랄 등을 가지고 있습니다. </p>
                <p>과학적 연구 실험을 통해 초록입홍합이 결합조직, 관절, 또한 항염증 활동 등에 도움이 되어 부작용 없는 자연적인 통증 완화에 기여한다는 것이 밝혀졌으며, 현재 저희는 뉴질랜드 인근 해안에 지속적인 수확이 가능한 홍합 농장을 운영하고 있습니다.</p>
                <p>저희는 활력, 다양한 종류의 조직 재생 및 유지, 미용을 위한 영양제, 남성 건강 제품 등 사람들을 위한 여러 범위의 제품을 추가했습니다.</p>
                <p>또한 저희의 모든 제품은 지속적이고 윤리적인 방법으로 공급되고 있습니다.</p>
              </div>
                <div className="ourstory__content-button">
                <Link to="/commitment">
                  <button>더 보기</button>
                </Link>
              </div>
            </div>
          </div>
          <div className="ourstory__content">
            <img src={mussel} alt="green lipped mussel"/>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurStory;